import { create, windowScheduler, indexedResolver } from "@yornaath/batshit";
import { qualifyUrl } from "util/URLUtils";
import EnterpriseApiRoutes from "common/ApiRoutes";
import glFetch from "logic/rest/FetchProvider";
import { stringifyFilters } from "security-app/components/common/Filters/stringifyFilters";
export const fetchAssetLabels = async (page, perPage, query = void 0) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (query) params.push(`query=${encodeURI(query)}`);
  return glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.assetLabels(params.join("&")).url)).then(
    (response) => {
      var _a;
      return {
        ...response,
        assets: (_a = response.assets) == null ? void 0 : _a.map((asset) => ({ id: asset._id, name: asset.name }))
      };
    }
  );
};
export const fetchAssets = async (page, perPage, query = void 0, orderBy = void 0, direction = void 0, filters = {}) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (query) params.push(`query=${encodeURI(query)}`);
  if (orderBy) {
    if (orderBy.includes("risk_score")) {
      params.push("sort=risk_score_normalized");
    } else {
      params.push(`sort=${orderBy}`);
    }
  }
  if (direction) params.push(`direction=${direction}`);
  if (filters && Object.keys(filters).length > 0) {
    params.push(`filters=${encodeURIComponent(stringifyFilters(filters))}`);
  }
  return glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.index(params.join("&")).url));
};
export const fetchAssetsFilterOptions = async ({ fields }) => {
  const payload = {
    fields
  };
  return glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.filters().url), payload);
};
export const fetchAssetsForEventPreview = async (page, perPage, orderBy, direction, config, assetType) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (orderBy) {
    params.push(`sort=${orderBy}`);
  }
  if (direction) params.push(`direction=${direction}`);
  if (assetType) params.push(`asset_type=${assetType}`);
  return glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.eventPreview(params.join("&")).url), config);
};
export const fetchAsset = async (assetId) => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.singleAsset(assetId).url));
const byIdsFetcher = (assetIds) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.assetByIds().url), {
  asset_ids: assetIds
});
const batcherAssetByIds = create({
  fetcher: byIdsFetcher,
  resolver: indexedResolver(),
  scheduler: windowScheduler(10)
});
export const getAssetById = async (assetId) => batcherAssetByIds.fetch(assetId);
export const deleteAsset = async ({ assetId }) => glFetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.singleAsset(assetId).url));
export const updateAsset = async ({ assetId, asset }) => glFetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.singleAsset(assetId).url), asset);
export const createAsset = async ({ asset }) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.new().url), asset);
export const fetchPriorities = async () => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.priorities.index().url));
export const fetchCategories = async () => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.categories.index().url));
export const fetchCategoriesInUse = async ({
  assetType,
  query,
  page,
  perPage
}) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (assetType) params.push(`asset_type=${assetType}`);
  if (query) params.push(`query=${encodeURIComponent(query)}`);
  return glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.categories.inUse(params.join("&")).url));
};
export const addPriority = async ({ priority }) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.priorities.add().url), priority);
export const reprioritizePriorities = async ({ payload }) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.priorities.reprioritize().url), payload);
export const updatePriority = async ({ priorityId, priority }) => glFetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.priorities.update(priorityId).url), priority);
export const deletePriority = async ({ priorityId }) => glFetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.priorities.delete(priorityId).url));
export const addCategory = async ({ category }) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.categories.add().url), category);
export const updateCategory = async ({ categoryId, category }) => glFetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.categories.update(categoryId).url), category);
export const deleteCategory = async ({ categoryId }) => glFetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.categories.delete(categoryId).url));
export const bulkAddCategories = async ({ assetIds, categories }) => {
  glFetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.bulkAddCategories().url), {
    asset_ids: assetIds,
    categories
  });
};
export const fetchAssetSources = async (page, perPage, query = null, orderBy = null, direction = null, filters = {}) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (query) params.push(`query=${encodeURI(query)}`);
  if (filters && Object.keys(filters).length > 0) {
    params.push(`filters=${encodeURI(stringifyFilters(filters))}`);
  }
  if (orderBy) {
    params.push(`sort=${orderBy}`);
  }
  if (direction) {
    params.push(`direction=${direction}`);
  }
  return glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.index(params.join("&")).url));
};
export const fetchAssetSource = async (sourceId) => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.details(sourceId).url));
export const createAssetSource = async ({ source }) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.new().url), source);
export const updateAssetSource = async ({
  sourceId,
  source
}) => glFetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.update(sourceId).url), source);
export const deleteAssetSource = async ({ sourceId }) => glFetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.delete(sourceId).url));
export const fetchMS365DeploymentTypes = async () => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.ms365DeploymentTypes().url));
export const fetchAssetSourceMappings = async (sourceId, page, perPage) => {
  const params = [`page=${page}`, `per_page=${perPage}`, "sort=updated_at", "direction=desc"];
  return glFetch(
    "GET",
    qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.mappings.index(sourceId, params.join("&")).url)
  );
};
export const fetchAssetSourceMapping = async (sourceId, mappingId) => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.mappings.details(sourceId, mappingId).url));
export const createAssetSourceMapping = async ({
  sourceId,
  mapping
}) => new Promise((resolve, reject) => {
  fetch(qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.mappings.new(sourceId).url), {
    method: "POST",
    body: JSON.stringify(mapping),
    headers: {
      "Content-Type": "application/json",
      "X-Requested-By": "XMLHttpRequest"
    }
  }).then(async (response) => {
    const respBody = await response.json();
    if (response.ok) resolve(respBody);
    else reject(respBody);
  });
});
export const updateAssetSourceMapping = async ({
  sourceId,
  mappingId,
  mapping
}) => new Promise((resolve, reject) => {
  fetch(qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.mappings.update(sourceId, mappingId).url), {
    method: "PUT",
    body: JSON.stringify(mapping),
    headers: {
      "Content-Type": "application/json",
      "X-Requested-By": "XMLHttpRequest"
    }
  }).then(async (response) => {
    const respBody = await response.json();
    if (response.ok) resolve(respBody);
    else reject(respBody);
  });
});
export const deleteAssetSourceMapping = async ({ sourceId, mappingId }) => glFetch(
  "DELETE",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.mappings.delete(sourceId, mappingId).url)
);
export const importAssets = async (sourceId, mappingId) => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.mappings.import(sourceId, mappingId).url));
export const testAssetSource = async ({ source }) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.testNew().url), source);
export const testNewAssetSourceMapping = async ({
  sourceId,
  mapping
}) => {
  const mappingId = mapping.id || "new";
  const payload = { asset_import_backend_configuration: mapping };
  return glFetch(
    "POST",
    qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.mappings.testNew(sourceId, mappingId).url),
    payload
  );
};
export const testSavedAssetSource = async (sourceId) => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.testSaved(sourceId).url));
export const bulkTestAssetSource = async ({ ids }) => {
  const requestBody = {
    ids
  };
  return glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.bulkTest().url), requestBody);
};
export const testSavedAssetSourceMapping = async (sourceId, mappingId) => glFetch(
  "GET",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.mappings.testSaved(sourceId, mappingId).url)
);
export const toggleMappingSync = async ({
  sourceId,
  mappingId,
  enabled,
  interval_hours
}) => {
  const requestBody = {
    enabled: !enabled,
    interval_hours
  };
  return glFetch(
    "POST",
    qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.sources.mappings.toggleSync(sourceId, mappingId).url),
    requestBody
  );
};
export const fetchScanners = async (page, perPage, query, orderBy = "title", direction = "asc", filters = {}) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (query) params.push(`query=${encodeURI(query)}`);
  if (orderBy) params.push(`sort=${orderBy}`);
  if (direction) params.push(`direction=${direction}`);
  if (filters && Object.keys(filters).length > 0) {
    params.push(`filters=${encodeURI(stringifyFilters(filters))}`);
  }
  return glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.scanners.index(params.join("&")).url));
};
export const fetchScannerDetails = async (scannerId) => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.scanners.details(scannerId).url));
export const addScanner = async ({ scanner }) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.scanners.new().url), scanner);
export const deleteScanner = async ({ scannerId }) => glFetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.scanners.delete(scannerId).url));
export const editScanner = async ({ scanner }) => glFetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.scanners.edit(scanner.id).url), scanner);
export const toggleScannerSync = async ({
  scannerId,
  enabled,
  interval_hours
}) => {
  const requestBody = {
    enabled: !enabled,
    interval_hours
  };
  return glFetch(
    "POST",
    qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.scanners.schedule(scannerId).url),
    requestBody
  );
};
export const testNewScannerConnection = async ({ scanner }) => glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.scanners.testNewScannerConnection().url), scanner);
export const testScannerConnection = async ({ id }) => glFetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.scanners.testScannerConnection(id).url));
export const importVulnerabilityScans = async (scannerId) => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Assets.scanners.import(scannerId).url));
